import { render, staticRenderFns } from "./MoleculeFeedSectionContentFooter.vue?vue&type=template&id=aa02e40e"
import script from "./MoleculeFeedSectionContentFooter.vue?vue&type=script&lang=js"
export * from "./MoleculeFeedSectionContentFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports